import {Component, Input, OnInit} from '@angular/core';
import {FieldCropService} from '../../stores/field-crop.service';
import {Field} from 'shared';
import DataSource from 'devextreme/data/data_source';

@Component({
  selector: 'app-field-editor-map-crop-list',
  templateUrl: './field-editor-map-crop-list.component.html',
  styleUrls: ['./field-editor-map-crop-list.component.scss']
})
export class FieldEditorMapCropListComponent implements OnInit {

  @Input()
  field: Field;

  selectedIndex = 0;

  tabs = [
    {
      id: 0,
      text: 'Cultures',
    },
    {
      id: 1,
      text: 'Archives',
    },
  ];
  ds: DataSource;

  constructor(
    private fieldCropService: FieldCropService,
  ) {
  }

  ngOnInit(): void {
    this.ds = this.fieldCropService.newDataSource();
    this.ds.filter([['field_id', '=', this.field.id], ['archived_at', '=', null]]);
  }

  selectTab(e: any) {
    switch (e.itemData.id) {
      case 0:
        this.loadCrops();
        break;
      case 1:
        this.loadArchive();
        break;
    }
  }

  itemClick(e: any) {
    const notification = e.itemData;
  }

  contextMenuClick(e: any) {
    const id = e.itemData.id;
    switch (e.itemData.action) {
      case 'read':
        break;
    }
  }

  private loadCrops() {
    this.ds.filter([['field_id', '=', this.field.id], ['archived_at', '=', null]]);
    this.ds.reload();
  }

  private loadArchive() {
    this.ds.filter([['field_id', '=', this.field.id], ['archived_at', '<>', null]]);
    this.ds.reload();
  }
}
